export default "__VITE_ASSET__u2L2TL3w__"